export default "__VITE_ASSET__z5dznF15__"